import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StudentprofilemainComponent } from '../../eduman/student/studentprofilemain/studentprofilemain.component';


const routes: Routes = [
  {
    path: 'profile',
    component: StudentprofilemainComponent,
    data: {
      title: "Profile",
      breadcrumb: "Profile"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingRoutingModule { }
